// extracted by mini-css-extract-plugin
export var container = "_f3-0";
export var icon = "_f3-1";
export var text = "_f3-2";